import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, ArrowRight } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { INSIGHTS } from '../data/insights';

const CATEGORIES = ['Corporate Finance', 'Debt Markets', 'Working Capital & MSME', 'Real Estate Finance', 'RBI & Lending Regulations'];
const formatDate = (iso) => new Date(iso).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });

const InsightsHubPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <WhatsAppButton />

      <div className="bg-white pt-24 sm:pt-28 md:pt-32 pb-16 sm:pb-20">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-sm text-slate-500 mb-4 sm:mb-6">
              <Link to="/" className="hover:text-emerald-600 transition-colors">Home</Link>
              <ChevronRight className="w-3.5 h-3.5 text-slate-400" />
              <span className="text-slate-700 font-medium">Capital Insights</span>
            </nav>

            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-3 sm:mb-4 leading-[1.1]">
              Capital <span className="text-emerald-600">Insights</span>
            </h1>
            <p className="text-lg sm:text-xl text-slate-600 mb-6 sm:mb-8 max-w-3xl">
              Perspectives on corporate finance, debt markets, working capital, real estate finance and India's evolving lending environment.
            </p>

            <div className="flex flex-wrap gap-2 mb-12" data-testid="insights-categories">
              {CATEGORIES.map((c) => (
                <span key={c} className="px-4 py-1.5 bg-slate-100 text-slate-700 rounded-full text-sm font-medium">{c}</span>
              ))}
            </div>

            <div className="grid md:grid-cols-3 gap-6" data-testid="insights-hub-grid">
              {INSIGHTS.map((a) => (
                <Link
                  key={a.slug}
                  to={`/insights/${a.slug}`}
                  className="group bg-white rounded-xl border-2 border-slate-200 hover:border-emerald-500 hover:shadow-xl transition-all duration-300 p-8 flex flex-col"
                  data-testid={`insights-hub-card-${a.slug}`}
                >
                  <div className="flex items-center gap-3 text-xs mb-4">
                    <span className="px-3 py-1 bg-emerald-100 text-emerald-700 rounded-full font-semibold">{a.category}</span>
                    <span className="text-slate-400">{formatDate(a.date)}</span>
                  </div>
                  <h2 className="text-lg font-bold text-slate-900 leading-snug group-hover:text-emerald-700 transition-colors">{a.title}</h2>
                  <p className="mt-3 text-sm text-slate-600 leading-relaxed flex-1">{a.excerpt}</p>
                  <span className="mt-5 inline-flex items-center gap-1.5 text-emerald-700 font-semibold text-sm group-hover:gap-2.5 transition-all">
                    Read More <ArrowRight className="w-4 h-4" />
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default InsightsHubPage;
